// Video Controller

( function( $, window, document, undefined ) {

	let VideoController = class VideoController {
		constructor( $wrapper ) {
			const _ = this;

			_.$wrapper = $wrapper;

			if ( !_.video ) {
				_._lazyload();
			}
		}
	
		/**
		 * Load the HTML5 <video> element JIT (Just in Time).
		 * @return {self}
		 */
		_lazyload() {
			const _ = this;

			// See if there is already a video in the wrapper
			// Return early if found
			let $video = _.$wrapper.find('video');

			if ( $video.length ) {
				_.video = $video.get(0);
				return _;
			}

			// else, Create the video element and append to the wrapper
			$video = $('<video autoplay muted playsinline></video>');
			$video.attr( 'poster', _.$wrapper.css('backgroundImage').replace( /url\(\"([^\"]*)\"\)/, '$1' ) );

			let $source = $('<source></source>');
			$source.attr( 'src', _.$wrapper.attr('data-video') );

			$video.append( $source );
			$video.css( 'visibility', 'hidden' );

			// Listen for ready to play events to prevent buffer flickering
			$video.on( 'canplay', () => {
				$video.css( 'visibility', '' );
			} );

			_.$wrapper.append( $video );
			_.video = $video.get(0);

			return _;
		}

		/**
		 * Pause the video.
		 * @return {self} 
		 */
		pause() {
			const _ = this;

			if ( _.video ) {
				_.video.pause();
			}

			return _;
		}

		/**
		 * Check if the video is paused.
		 * @return {boolean}
		 */
		paused() {
			const _ = this;

			if ( !_.video ) {
				return null;
			}

			return _.video.paused;
		}

		/**
		 * Play the video.
		 * @return {self} 
		 */
		play() {
			const _ = this;

			if ( _.video ) {
				_.video.play();
			}

			return _;
		}

		/**
		 * Toggle the video between play and pause.
		 * @return {self}
		 */
		toggle() {
			const _ = this;

			if ( _.video ) {
				if ( _.paused() ) {
					_.play();
				} else {
					_.pause();
				}
			}

			return _;
		}

		/**
		 * Stop the video and rewind it back to the start.
		 * @return {self} 
		 */
		rewind() {
			const _ = this;

			if ( _.video ) {
				_.pause();
				_.video.currentTime = 0;
			}

			return _;
		}
	};

	window.VideoController = VideoController;
	
} )( jQuery, window, document );
